<template>
  <div>
    <v-row>
      <v-col 
        cols="12" 
        md="12"
        class="py-0 px-7">
        <!-- <v-card
          outlined
          class="pa-2 mb-4"
          style="border-radius: 10px;">
          <swiper 
            class="swiper"
            ref="swiper"
            :options="{ slidesPerView: 'auto' }">
            <swiper-slide 
              class="pr-3"
              style="width: auto;">
              <v-btn
                to="/officer"
                large
                :color="set_color"
                class="text-capitalize white--text px-0"
                min-width="45"
                min-height="45"
                style="border-radius: 10px; 
                      box-shadow: rgba(0, 0, 0, 0.35) 0px -50px 36px -28px inset;">
                <v-avatar 
                  :color="set_color" 
                  size="30"
                  style="box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;">
                  <v-icon>mdi-plus-thick</v-icon>
                </v-avatar>
              </v-btn>
            </swiper-slide>
            
            <swiper-slide 
              v-for="(item, index) in process.user ? 20 : list.user" 
              :key="index" 
              :class="index < 1 ? 'pr-3' : index < list.user.length ? 'pr-3' : 'px-3'"
              style="width: auto;">
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.user"
                type="avatar"
                tile>
                <div>
                  <v-card v-if="!process.user && list.user.length > 0"
                    :to="`/user/${item.id}`"
                    flat
                    color="transparent"
                    class="border-radius d-flex align-center justify-center">
                    <div 
                      class="text-center"
                      style="width: 45px;">
                      <v-avatar 
                        size="45" 
                        tile>
                        <v-img 
                          alt="diskominfo" 
                          :src="item.image_url === '' ? require('@/assets/image/member_default.jpg') : item.image_url"
                          class="ma-auto"
                          style="border-radius: 10px;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                color="white">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>

                      <div
                        class="caption one-line mt-1"
                        style="opacity: 60%;">
                        {{ item.name }}
                      </div>
                    </div>
                  </v-card>
                </div>
              </v-skeleton-loader>
            </swiper-slide>
          </swiper>
        </v-card> -->

        <v-row>
          <v-col 
            cols="12" 
            md="4">
            <v-card
              min-height="175"
              class="border-radius"
              color="#FFFFFF"
              style="box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;">
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.dashboard"
                type="image">
                <v-card-text>
                  <div
                    class="d-flex align-start">
                    <div>
                      <div class="body-1 black--text font-weight-bold">
                        Total Agenda
                      </div>

                      <!-- <div 
                        class="caption d-flex align-center mb-12">
                        <v-icon small>mdi-file-sign</v-icon>
                        
                        <span
                          class="ml-1">
                          Total data laporan
                        </span>
                      </div> -->
                    </div>

                    <v-spacer />

                    <div>
                      <v-img 
                        width="60"
                        height="60"
                        alt="diskominfo" 
                        :src="require(`@/assets/image/time/${isDay}.png`)"
                        class="ma-auto">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              color="white">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </div>
                  </div>

                  <div class="d-flex align-center">
                    <div class="d-flex align-end">
                      <span 
                        class="text-h3 black--text font-weight-bold">
                        {{ list.count.total_agenda | number }}
                      </span>

                      <!-- <v-icon 
                        size="28" 
                        color="green" 
                        class="mb-1">
                        mdi-arrow-up-thick
                      </v-icon>

                      <span 
                        class="font-weight-bold mb-1 green--text">
                        5%
                      </span> -->
                    </div>

                    <v-spacer />

                    <div class="black--text">
                      <div v-if="clock.time.length > 0">
                        <div 
                          class="caption" 
                          style="opacity: 60%;">
                          {{ clock.date | date }}
                        </div>

                        <div 
                          class="body-1 font-weight-bold">
                          {{ clock.time }}
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-skeleton-loader>
            </v-card>
          </v-col>
          
          <v-col 
            cols="12" 
            md="4">
            <v-card
              min-height="175"
              class="border-radius"
              color="#FFFFFF"
              style="box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;">
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.dashboard"
                type="image">
                <v-card-text
                  class="pb-1">
                  <div
                    class="d-flex align-start">
                    <div>
                      <v-avatar
                        tile
                        size="50"
                        :color="set_color_rgb"
                        style="border-radius: 15px !important;">
                        <v-icon size="30" :color="set_color">mdi-account-multiple-check-outline</v-icon>
                      </v-avatar>
                    </div>

                    <v-spacer />

                    <div>
                      <span
                        class="mr-1">
                        Lihat
                      </span>
                      
                      <router-link
                        to="/berita">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </router-link>
                    </div>
                  </div>
                </v-card-text>

                <v-card-text>
                  <div
                    class="body-2 mb-3">
                    Total Berita
                  </div>

                  <div
                    class="text-h4 font-weight-bold black--text">
                    {{ list.count.total_berita | number }}
                  </div>
                </v-card-text>
              </v-skeleton-loader>
            </v-card>
          </v-col>

          <v-col 
            cols="12" 
            md="4">
            <v-card
              min-height="175"
              class="border-radius"
              color="#FFFFFF"
              style="box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;">
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.dashboard"
                type="image">
                <v-card-text
                  class="pb-1">
                  <div
                    class="d-flex align-start">
                    <div>
                      <v-avatar
                        tile
                        size="50"
                        :color="set_color_rgb"
                        style="border-radius: 15px !important;">
                        <v-icon size="30" :color="set_color">mdi-account-multiple-remove-outline</v-icon>
                      </v-avatar>
                    </div>

                    <v-spacer />

                    <div>
                      <span
                        class="mr-1">
                        Lihat
                      </span>
                      
                      <router-link
                        to="/berita">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </router-link>
                    </div>
                  </div>
                </v-card-text>

                <v-card-text>
                  <div
                    class="body-2 mb-3">
                    Total Pengumuman
                  </div>

                  <div
                    class="text-h4 font-weight-bold black--text">
                    {{ list.count.total_pengumuman | number }}
                  </div>
                </v-card-text>
              </v-skeleton-loader>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            md="12">
            <v-card
              flat
              color="#f9f9f9"
              class="border-radius">
              <v-card-title 
                class="body-1 font-weight-bold black--text">
                Grafik
              </v-card-title>

              <v-card-subtitle 
                class="caption pb-0 d-flex align-center">
                <v-icon small>mdi-chart-line</v-icon>
                
                <span
                  class="ml-1">
                  Sampai Dengan <b>{{ clock.date | date }}</b>
                </span>
              </v-card-subtitle>

              <v-card-text
                class="pr-2"
                :class="process.grafik ? 'pa-4' : 'pa-0'">
                <v-skeleton-loader
                  class="ma-auto"
                  :loading="process.grafik"
                  type="image">
                  <div>
                    <div v-if="!process.grafik && Object.keys(this.list.bar).length > 0">
                      <apexchart 
                        height="375" 
                        type="bar"
                        :options="list.bar.chartOptions" 
                        :series="list.bar.series">
                      </apexchart>
                    </div>
                  </div>
                </v-skeleton-loader>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        clock: {
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          time: ''
        },
        count: {},
        list: {
          count:{},
          bar: {},
          announcement: []
        },
        pagination: {
          user: {}
        },
        process: {
          user: false,
          grafik: false,
          dashboard: false,
          announcement: false
        }
      }
    },
    computed: {
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      rps() {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      setInterval(this.updateTime, 1000)
      
      this.fetch()
    },
    methods: {
      fetch () {
        this.fetchGrafik()
      },
      async fetchGrafik () {
        this.process.grafik = true
        
        let params = {
          year: (new Date()).getFullYear(),
          unit_id: this.user.unit_id
        }

        await get(`admin/dashboard/data`, { params })
        .then(response => {
          let res = response.data

          this.process.grafik = false

          if (res.status === 200) {
            this.list.count = res.results
            this.list.bar = {
              series: res.results.arr_berita,
              chartOptions: {
                chart: {
                  animations: {
                    enabled: true,
                    easing: 'linear',
                    dynamicAnimation: {
                      speed: 1000
                    }
                  },
                  toolbar: {
                    show: true
                  },
                  zoom: {
                    enabled: true
                  }
                },
                stroke: {
                  width: 3,
                  curve: 'smooth'
                },
                dataLabels: {
                  enabled: false
                },
                colors: ['#FF9800', '#00BCD4', '#9C27B0', '#F44336', '#2196F3', '#4CAF50'],
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return Math.round(value)
                    }
                  }
                },
                xaxis: {
                  categories: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "Mei",
                    "Jun",
                    "Jul",
                    "Agu",
                    "Sep",
                    "Okt",
                    "Nov",
                    "Des"
                  ]
                }
              }
            }
          }
        })
      },
      updateTime () {
        let cd = new Date()

        this.clock.time = this.zeroPadding(cd.getHours(), 2) + ':' + this.zeroPadding(cd.getMinutes(), 2) + ':' + this.zeroPadding(cd.getSeconds(), 2)
      },
      zeroPadding (num, digit) {
        let zero = ''

        for(let i = 0; i < digit; i++) {
          zero += '0'
        }
        return (zero + num).slice(-digit)
      }
    }
  }
</script>

